export function getView(question_type_id, question_id) {
  if (question_type_id?.includes('break')) return false
  return question_type_id || question_id !== 'new'
}
